import { useContext } from "react";
import { UserContext } from "../userContext/userContext";
import useLogout from "../hooks/useLogout";
import '../App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { NavLink } from "react-router-dom";

function HeaderMembers() {
  const { userState } = useContext(UserContext);
  const isLogged = userState.isLogged;
  const logout = useLogout();

  return (
    <>
      <img src="/bandeau.jpg" className="banner-img" alt="Bandeau LSR 47" />
      <div className="App">
        <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect className="site-navbar">
          <Container fluid="lg" className="site-navbar-container">
            <Navbar.Toggle aria-controls="members-navbar" />
            <Navbar.Collapse id="members-navbar" className="justify-content-center">
              <Nav className="site-nav">
                <Nav.Link as={NavLink} to="/ca/crca">Compte-rendu CA</Nav.Link>
                <Nav.Link as={NavLink} to="/ca/galerie">Galerie</Nav.Link>
                <NavDropdown title="Evenements" id="nav-dropdown-members-evenements">
                  <NavDropdown.Item as={NavLink} to="/ca/evenements/a-venir">
                    Evenements a venir
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/ca/evenements/passes">
                    Evenements passes
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/ca/evenements/external">
                    Que se passe-t-il ailleurs?
                  </NavDropdown.Item>
                </NavDropdown>
                {!isLogged && <Nav.Link href="/login">Espace adherents</Nav.Link>}
                {isLogged && (
                  <Nav.Link
                    onClick={logout}
                    href="/"
                  >
                    Deconnexion
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default HeaderMembers;
